import { useState, useEffect } from 'react'
import { getUserNotificationSettings } from '../api'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { toast } from '@sales-center/components'
import { unwrapResult } from '@reduxjs/toolkit'
import { IUserNotificationsSettings } from '../typings'

export const useGetUserNotificationSettings = () => {
  const dispatch = useAppDispatch()

  const [notificationSetting, setNotificationSetting] =
    useState<IUserNotificationsSettings>()
  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result: any = await dispatch(getUserNotificationSettings())

        if (mounted) {
          if (getUserNotificationSettings.fulfilled.match(result)) {
            setNotificationSetting(unwrapResult(result))
            setStatus('success')
          } else {
            setStatus('fail')
            toast.error(result.payload.message)
          }
        }
      } catch (error) {
        if (mounted) {
          setStatus('fail')
        }
      } finally {
        setStatus('success')
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return { status, notificationSetting }
}
